module.exports = __webpack_public_path__ + "static/word-guess-game-544fdceb1887f75efc672296a10e5b37.jpg";